function debounce(fn, delay) {
  let timeoutID;
  return function (...args) {
    if (timeoutID) clearTimeout(timeoutID);
    timeoutID = setTimeout(() => {
      fn.apply(this, args);
    }, delay);
  };
}

const getLeftPadding = () => {
  const elem = document.querySelector(".footer-block__newsletter");
  const elemStyles = window.getComputedStyle(elem);
  const marginLeft = parseFloat(elemStyles.marginLeft) + parseFloat(elemStyles.paddingLeft);
  const b = document.querySelector("body");

  b.style.setProperty("--margin-left", `${marginLeft}px`);
  return marginLeft;
};

const debouncedGetLeftPadding = debounce(getLeftPadding, 250);

window.addEventListener("DOMContentLoaded", () => {
  getLeftPadding();
});

window.addEventListener("resize", () => {
  debouncedGetLeftPadding();
});
